import { testimonials } from "@/mocks/testimonials";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function Testimonials() {
  return (
    <section id="depoimentos" className="relative w-full py-20 md:py-28 bg-organic-warm overflow-hidden">
      <div className="relative w-full px-4 sm:px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <ScrollReveal className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-4">
            Depoimentos
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            O que nossos{" "}
            <span className="text-primary-600">clientes dizem</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base md:text-lg">
            Mais de 15 anos conquistando clientes em Fortaleza com qualidade e sabor.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.1} staggerChildren staggerDelay={0.1}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
            {testimonials.map((t, idx) => (
              <div
                key={idx}
                className="p-6 md:p-7 rounded-2xl bg-background-50/80 border border-background-200/40 card-glow hover:border-primary-300/50 transition-all duration-500 hover:-translate-y-1.5"
              >
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: 5 }).map((_, i) => (
                    i < t.rating ? (
                      <i key={i} className="ri-star-fill text-lg text-secondary-400"></i>
                    ) : (
                      <i key={i} className="ri-star-line text-lg text-background-300"></i>
                    )
                  ))}
                </div>
                <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-5">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-user-3-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.city}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollReveal>

        {/* Google Rating Badge */}
        <ScrollReveal>
          <div className="flex items-center justify-center">
            <div className="inline-flex items-center gap-4 px-6 py-4 rounded-2xl bg-background-50/80 border border-background-200/40 card-glow transition-all duration-300">
              <div className="flex items-center gap-2">
                <i className="ri-google-fill text-xl text-foreground-700"></i>
                <span className="text-sm font-semibold text-foreground-800">Google</span>
              </div>
              <div className="flex items-center gap-1">
                <span className="text-lg font-bold text-foreground-950">4,1</span>
                <i className="ri-star-fill text-secondary-400"></i>
              </div>
              <span className="text-xs text-foreground-500">Avaliacao media</span>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}